<template>
  <div class="admin-card bg-white p-4">
    <div class="contacts-toolbar d-flex align-items-center justify-content-between mb-4">
      <div>
        <div class="text-muted small text-uppercase font-weight-bold">CMS</div>
        <h2 class="h4 font-weight-bold text-primary mb-0">Quản lý liên hệ</h2>
      </div>
      <div class="status-filter">
        <label for="contact-status-filter" class="small font-weight-bold mb-1">Lọc trạng thái</label>
        <b-form-select
          id="contact-status-filter"
          v-model="statusFilter"
          :options="filterOptions"
          size="sm"
          class="status-filter-select"
          :class="statusSelectClass(statusFilter)"
        />
      </div>
    </div>

    <b-table
      class="contacts-table"
      :items="filteredContacts"
      :fields="fields"
      :tbody-tr-class="contactRowClass"
      responsive
      show-empty
      empty-text="Không có liên hệ ở trạng thái này."
    >
      <template #cell(createdAt)="row">
        {{ formatDate(row.item.createdAt) }}
      </template>
      <template #cell(status)="row">
        <b-form-select
          :value="row.item.status"
          :options="statusOptions"
          class="contact-status-select"
          :class="statusSelectClass(row.item.status)"
          @change="changeStatus(row.item, $event)"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import { fetchContacts, updateContactStatus } from "../../api/admin";
import { isUnauthorizedError } from "../../utils/apiErrors";
import { formatDate } from "../../utils/formatters";

export default {
  name: "AdminContactsView",
  data: function data() {
    return {
      contacts: [],
      statusFilter: "ALL",
      statusOptions: ["NEW", "PROCESSING", "DONE"],
      filterOptions: ["ALL", "NEW", "PROCESSING", "DONE"],
      fields: [
        { key: "fullName", label: "Họ tên" },
        { key: "phone", label: "Số điện thoại" },
        { key: "email", label: "Email" },
        { key: "message", label: "Nội dung" },
        { key: "status", label: "Trạng thái" },
        { key: "createdAt", label: "Ngày tạo" }
      ]
    };
  },
  computed: {
    filteredContacts: function filteredContacts() {
      if (this.statusFilter === "ALL") {
        return this.contacts;
      }

      return this.contacts.filter(contact => contact.status === this.statusFilter);
    }
  },
  created: function created() {
    this.loadContacts();
  },
  methods: {
    formatDate,
    statusSelectClass: function statusSelectClass(status) {
      return `status-select-${(status || "all").toLowerCase()}`;
    },
    contactRowClass: function contactRowClass(contact, type) {
      if (type !== "row" || !contact || !contact.status) {
        return "";
      }

      return `contact-status-${contact.status.toLowerCase()}`;
    },
    async loadContacts() {
      try {
        const response = await fetchContacts();
        this.contacts = response.data;
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    },
    async changeStatus(contact, status) {
      try {
        await updateContactStatus(contact._id, status);
        this.$bvToast.toast("Cập nhật trạng thái thành công.", {
          variant: "success",
          solid: true
        });
        this.loadContacts();
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    }
  }
};
</script>

<style>
.status-filter {
  display: flex;
  flex-direction: column;
  width: 180px;
}

.contacts-table tbody tr.contact-status-new > td {
  background-color: #eaf4ff;
  border-top-color: #d2e6fa;
  border-bottom-color: #d2e6fa;
}

.contacts-table tbody tr.contact-status-processing > td {
  background-color: #fff3dc;
  border-top-color: #f4dfb5;
  border-bottom-color: #f4dfb5;
}

.contacts-table tbody tr.contact-status-done > td {
  background-color: #e8f6ed;
  border-top-color: #cde8d5;
  border-bottom-color: #cde8d5;
}

.contacts-table tbody tr.contact-status-new > td:first-child {
  border-left: 4px solid #3786c8;
}

.contacts-table tbody tr.contact-status-processing > td:first-child {
  border-left: 4px solid #d4982f;
}

.contacts-table tbody tr.contact-status-done > td:first-child {
  border-left: 4px solid #3a9a5d;
}

.contact-status-select,
.status-filter-select {
  font-weight: 700;
}

.status-filter-select.status-select-all {
  background-color: #f2f7fc;
  color: #40566d;
}

.contact-status-select.status-select-new,
.status-filter-select.status-select-new {
  background-color: #e3f1ff;
  border-color: #9ac6ed;
  color: #165b96;
}

.contact-status-select.status-select-processing,
.status-filter-select.status-select-processing {
  background-color: #fff0d1;
  border-color: #e9c77d;
  color: #805608;
}

.contact-status-select.status-select-done,
.status-filter-select.status-select-done {
  background-color: #e1f3e7;
  border-color: #9bcdaa;
  color: #246b3d;
}

@media (max-width: 575px) {
  .contacts-toolbar {
    align-items: flex-start !important;
    flex-direction: column;
    gap: 16px;
  }

  .status-filter {
    width: 100%;
  }
}
</style>
